/* Pilote Autrement · site v5 (15 oct 2026). Rien ne dépend de la souris : tout marche au doigt. */
(function () {
  var d = document, de = d.documentElement;
  var calme = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* EASA / FAA : ?authority=faa, sinon le dernier choix, sinon EASA */
  function lireAuth() {
    var q = new URLSearchParams(location.search).get('authority');
    if (q === 'faa' || q === 'easa') return q;
    try { return localStorage.getItem('p4-auth') || 'easa'; } catch (e) { return 'easa'; }
  }
  function poserAuth(a, anim) {
    if (!d.querySelector('[data-p5-switch]')) return;
    de.setAttribute('data-auth', a);
    try { localStorage.setItem('p4-auth', a); } catch (e) {}
    d.querySelectorAll('[data-p5-switch] button').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.auth === a ? 'true' : 'false'); });
    var u = new URL(location.href); u.searchParams.set('authority', a); history.replaceState(null, '', u);
    d.querySelectorAll('[data-p5-dev]').forEach(function (s) { appareils(s, a); });
    if (anim) d.querySelectorAll('.p5-pk__box [data-only="' + a + '"]').forEach(function (el) { el.classList.remove('p5-swap'); void el.offsetWidth; el.classList.add('p5-swap'); });
  }

  /* iPad + iPhone : un jeu par édition */
  function appareils(s, k) {
    var sets = s.querySelectorAll('.p5-dev__set'), ok = false;
    sets.forEach(function (x) { if (x.dataset.k === k) ok = true; });
    if (!ok) k = sets[0] && sets[0].dataset.k;
    sets.forEach(function (x) { x.classList.toggle('is-on', x.dataset.k === k); });
  }

  /* l'iPhone glisse un peu plus vite que l'iPad au défilement */
  function parallaxe() {
    if (calme) return;
    var els = [].slice.call(d.querySelectorAll('.p5-dev'));
    if (!els.length) return;
    var t = false;
    function f() {
      t = false;
      els.forEach(function (el) {
        var r = el.getBoundingClientRect(), vh = innerHeight;
        if (r.bottom < 0 || r.top > vh) return;
        var p = Math.max(-1, Math.min(1, (r.top + r.height / 2 - vh / 2) / vh));
        el.querySelectorAll('.p5-dev__set.is-on .p5-dev__iphone').forEach(function (i) { i.style.translate = '0 ' + (p * 26).toFixed(1) + 'px'; });
      });
    }
    addEventListener('scroll', function () { if (!t) { t = true; requestAnimationFrame(f); } }, { passive: true });
    f();
  }

  /* apparitions : visibles d'office si quelque chose ne marche pas */
  function apparitions() {
    var els = d.querySelectorAll('.p5-in');
    if (!('IntersectionObserver' in window) || calme) return;
    de.classList.add('p5-js');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -4% 0px' });
    els.forEach(function (e) {
      var r = e.getBoundingClientRect();
      if (r.top < innerHeight) e.classList.add('is-in'); else io.observe(e);
    });
    /* filet de sécurité : rien ne reste caché plus de 4 s */
    setTimeout(function () { els.forEach(function (e) { e.classList.add('is-in'); }); }, 4000);
  }

  /* galeries : flèches sur ordinateur, visionneuse plein écran au toucher */
  function galeries() {
    d.querySelectorAll('[data-p5-gal]').forEach(function (g) {
      var nav = g.parentNode.querySelector('[data-p5-galnav]');
      if (nav) nav.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () { var w = g.querySelector('button').offsetWidth + 12; g.scrollBy({ left: b.dataset.dir * w, behavior: 'smooth' }); });
      });
    });
    var v = d.querySelector('[data-p5-view]');
    if (!v) return;
    var img = v.querySelector('img'), cap = v.querySelector('p');
    d.querySelectorAll('[data-p5-gal] button').forEach(function (b) {
      b.addEventListener('click', function () {
        img.src = b.dataset.full; img.alt = b.querySelector('img').alt; cap.textContent = b.querySelector('small') ? b.querySelector('small').textContent : '';
        v.classList.add('is-open'); d.body.style.overflow = 'hidden';
      });
    });
    function fermer() { v.classList.remove('is-open'); d.body.style.overflow = ''; }
    v.addEventListener('click', function (e) { if (e.target !== img) fermer(); });
    addEventListener('keydown', function (e) { if (e.key === 'Escape') fermer(); });
  }

  /* en-tête, tiroir, barre d'achat */
  function entete() {
    var h = d.querySelector('.p5-head');
    if (h) { var f = function () { h.classList.toggle('is-scrolled', scrollY > 6); }; addEventListener('scroll', f, { passive: true }); f(); }
    var dr = d.querySelector('[data-p5-drawer]');
    d.querySelectorAll('[data-p5-burger]').forEach(function (b) { b.addEventListener('click', function () { dr && dr.classList.add('is-open'); }); });
    d.querySelectorAll('[data-p5-close]').forEach(function (b) { b.addEventListener('click', function () { dr && dr.classList.remove('is-open'); }); });
    var bar = d.querySelector('[data-p5-bar]'), cible = d.querySelector('[data-p5-buy]');
    if (bar && cible && 'IntersectionObserver' in window) {
      /* la barre apparaît dès que le bouton d'achat n'est pas à l'écran, au-dessus comme en dessous */
      var vus = new Map();
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { vus.set(e.target, e.isIntersecting && e.target.offsetParent !== null); });
        var un = false; vus.forEach(function (v) { if (v) un = true; });
        bar.classList.toggle('is-on', !un);
      });
      cible.querySelectorAll('form button, .p5-wait button').forEach(function (b) { io.observe(b); });
    }
    d.querySelectorAll('[data-p5-up]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var t = d.querySelector('[data-p5-buy]');
        if (t) t.scrollIntoView({ behavior: calme ? 'auto' : 'smooth', block: 'center' });
        var inp = t && t.querySelector('html[data-auth=faa] [data-only=faa] input[type=email]');
        if (inp) setTimeout(function () { inp.focus(); }, 500);
      });
    });
  }

  /* avis : les premiers seulement, puis « Show all » */
  function avis() {
    d.querySelectorAll('[data-p5-avis]').forEach(function (a) {
      var lim = parseInt(a.dataset.lim, 10) || 6, cs = a.querySelectorAll('.p5-av'), b = a.querySelector('[data-p5-more]');
      if (cs.length <= lim) { if (b) b.remove(); return; }
      cs.forEach(function (c, i) { if (i >= lim) c.classList.add('is-hidden'); });
      if (b) b.addEventListener('click', function () { cs.forEach(function (c) { c.classList.remove('is-hidden'); }); b.remove(); });
    });
  }


  /* galerie du haut des packs : points, flèches, glisser */
  function carrousels() {
    d.querySelectorAll('[data-p5-car]').forEach(function (c) {
      var t = c.querySelector('.p5-car__track'), ss = [].slice.call(t.children), ds = [].slice.call(c.querySelectorAll('.p5-car__dots button'));
      function idx() { var x = t.scrollLeft, best = 0, bd = 1e9; ss.forEach(function (s, i) { var dd = Math.abs(s.offsetLeft - t.offsetLeft - x - parseFloat(getComputedStyle(t).paddingLeft || 0) + parseFloat(getComputedStyle(t).scrollPaddingLeft || 0)); if (dd < bd) { bd = dd; best = i; } }); return best; }
      function aller(i) { i = Math.max(0, Math.min(ss.length - 1, i)); t.scrollTo({ left: ss[i].offsetLeft - ss[0].offsetLeft, behavior: calme ? 'auto' : 'smooth' }); }
      var r = false;
      t.addEventListener('scroll', function () { if (r) return; r = true; requestAnimationFrame(function () { r = false; var i = idx(); ds.forEach(function (b, k) { b.classList.toggle('is-on', k === i); }); }); }, { passive: true });
      ds.forEach(function (b, k) { b.addEventListener('click', function () { aller(k); }); });
      c.querySelectorAll('.p5-car__arr').forEach(function (b) { b.addEventListener('click', function () { var i = idx() + parseInt(b.dataset.dir, 10); if (i >= ss.length) i = 0; if (i < 0) i = ss.length - 1; aller(i); }); });
    });
  }

  /* à la souris, les galeries se tirent comme au doigt */
  function glisser() {
    d.querySelectorAll('.p5-gal, .p5-car__track').forEach(function (g) {
      var x0 = 0, s0 = 0, bouge = false, bas = false;
      g.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse' || e.button !== 0) return; bas = true; bouge = false; x0 = e.clientX; s0 = g.scrollLeft; });
      addEventListener('pointermove', function (e) { if (!bas) return; var dx = e.clientX - x0; if (!bouge && Math.abs(dx) > 6) { bouge = true; g.classList.add('is-drag'); } if (bouge) g.scrollLeft = s0 - dx; });
      addEventListener('pointerup', function () { if (!bas) return; bas = false; if (bouge) { g.classList.remove('is-drag'); var w = g.firstElementChild ? g.firstElementChild.offsetWidth + 12 : 300; g.scrollTo({ left: Math.round(g.scrollLeft / w) * w, behavior: 'smooth' }); } });
      g.addEventListener('click', function (e) { if (bouge) { e.stopPropagation(); e.preventDefault(); bouge = false; } }, true);
    });
  }

  /* l'iPad + iPhone suit la souris */
  function inclinaison() {
    if (calme || !matchMedia('(hover:hover) and (pointer:fine)').matches) return;
    d.querySelectorAll('.p5-dev').forEach(function (el) {
      var zone = el.closest('.p5-hero, .p5-pk') || el.parentNode;
      zone.classList.add('p5-tilt');
      zone.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        el.style.transform = 'rotateY(' + (x * 10).toFixed(2) + 'deg) rotateX(' + (-y * 8).toFixed(2) + 'deg)';
      });
      zone.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
    /* les pages penchent un peu vers le curseur */
    d.querySelectorAll('.p5-gal button, .p5-car__s:not(.p5-car__s--dev), .p5-covers figure').forEach(function (b) {
      var img = b.querySelector('img'); if (!img) return;
      b.addEventListener('pointermove', function (e) {
        var r = b.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        img.style.transform = 'perspective(900px) translateY(-6px) rotateY(' + (x * 7).toFixed(2) + 'deg) rotateX(' + (-y * 6).toFixed(2) + 'deg) scale(1.02)';
      });
      b.addEventListener('pointerleave', function () { img.style.transform = ''; });
    });
  }


  /* offre de lancement : compte à rebours, caché une fois fini */
  function lancement() {
    d.querySelectorAll('[data-p5-launch]').forEach(function (el) {
      var fin = Date.parse(el.dataset.p5Launch), t = el.querySelector('[data-p5-cd]');
      if (isNaN(fin)) return;
      function deux(n) { return (n < 10 ? '0' : '') + n; }
      function tic() {
        var r = Math.floor((fin - Date.now()) / 1000);
        if (r <= 0) { el.hidden = true; return; }
        el.hidden = false;
        var j = Math.floor(r / 86400), h = Math.floor(r % 86400 / 3600), m = Math.floor(r % 3600 / 60), s = r % 60;
        t.textContent = (j ? j + 'd ' : '') + deux(h) + 'h ' + deux(m) + 'm ' + deux(s) + 's';
        setTimeout(tic, 1000);
      }
      tic();
    });
  }

  function boot() {
    poserAuth(lireAuth(), false);
    d.querySelectorAll('[data-p5-switch] button').forEach(function (b) { b.addEventListener('click', function () { poserAuth(b.dataset.auth, true); }); });
    d.querySelectorAll('[data-p5-dev]').forEach(function (s) { if (!s.querySelector('.is-on')) appareils(s, s.dataset.k || ''); });
    avis(); apparitions(); galeries(); carrousels(); glisser(); lancement(); inclinaison(); entete(); parallaxe();
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();
